import * as Business         from '../business';
import * as ContactActions   from '../contacts/actions';
import * as ContactSelectors from '../contacts/selectors';
import * as Forms            from '../components/forms';
import * as Phone            from 'libphonenumber-js';
import * as User             from '../user';
import { connect }           from 'react-redux';
import Badge                 from '../components/badge';
import FetchFromServer       from '../components/fetch_from_server';
import Link                  from '../components/link';
import Navbar                from '../components/navbar';
import NotFoundPage          from '../components/not_found_page';
import React                 from 'react';
import Swal                  from 'sweetalert2';
import withReactContent      from 'sweetalert2-react-content';


const sweetAlert = withReactContent(Swal);


export default connect(
  (state, { businessID, contactID }) => ({
    businessID,
    statuses:         ContactSelectors.getContactStatuses(state, contactID),
    contact:          ContactSelectors.getContact(state, contactID),
    isAdmin:          User.isAdmin(state, businessID),
    paymentsSettings: Business.getPaymentsSettings(state, businessID)
  }),
  (dispatch, { businessID, contactID, navigateBackTo }) => ({
    load: () => dispatch(ContactActions.readContact(contactID, businessID)),
    save: ({ amount, description, deposit }) => dispatch(ContactActions.requestPayment({ businessID, amount, deposit, description, customerID: contactID, params: { showDefaultErrorUI: false } })),
    navigateBackTo
  })
)(InvoicePage);


export function InvoicePage({ contact, save, load, statuses, navigateBackTo, isAdmin, paymentsSettings }) {
  const isPaymentsAvailable = paymentsSettings?.available;
  const isPaymentsEnabled   = paymentsSettings?.enabled;
  const isPaymentsLiveMode  = paymentsSettings?.liveMode;
  const stripeURL           = paymentsSettings?.stripeURL;

  const canViewInvoicePage = isPaymentsAvailable && (isPaymentsLiveMode || isAdmin);
  const showForm           = isPaymentsEnabled && contact;

  async function onSave({ amount, description, deposit }) {
    const onlyDigits     = amount.replace(/\D/g, '');
    const amountAsString = `${onlyDigits.slice(0, -2)}.${onlyDigits.slice(-2)}`;

    await save({ amount: amountAsString, description, deposit });
    await sweetAlert.fire({
      html: <SuccessAlertText {...{ isPaymentsLiveMode }}/>,
      type: 'success'
    });

    navigateBackTo('../');
  }

  function onCancel() {
    navigateBackTo('../');
  }

  if (!canViewInvoicePage)
    return <NotFoundPage/>;

  return (
    <React.Fragment>
      <Navbar title="Request Payment">
        <Navbar.LeftButton label="Cancel" onClick={onCancel}/>
        <Navbar.RightButton/>
      </Navbar>
      <FetchFromServer {...{ statuses, load, pullToRefresh: false }}>
        <div className="page-content">
          {showForm && (
            <Forms.Form save={onSave} validate={validate}>
              <InvoiceFields {...{ contact, isPaymentsLiveMode, stripeURL }}/>
            </Forms.Form>
          )}
        </div>
      </FetchFromServer>
    </React.Fragment>
  );
}


function SuccessAlertText({ isPaymentsLiveMode }) {
  return (
    <React.Fragment>
      {!isPaymentsLiveMode && (<Badge {...{ color: 'orange', text: 'Test' }}/>)}
      Sent Payment Request
    </React.Fragment>
  );
}


function validate(fields) {
  if (!fields.amount || fields.amount === '$0.00')
    throw Error('Please provide a valid total amount');
}


function InvoiceFields({ contact, isPaymentsLiveMode, stripeURL, ...form }) {
  const emailAddress = contact?.contact.email?.address;
  const phoneNumber  = contact?.contact.phone?.number;

  return (
    <div className="invoice-form">
      {!isPaymentsLiveMode && (
        <section className="block">
          <Badge {...{ color: 'orange', text: 'Test Mode' }}/>
          <p>You are currently testing our Payments feature. Charges will not be made to the customer&apos;s card, and all messages will still be sent.</p>
          <p>If you would like to start accepting payments for your business, <Link href={stripeURL} external>connect your bank account</Link>.</p>
        </section>
      )}
      <div className="list block">
        <ul className="inline-labels">
          {contact && <Forms.Field label="Name:" value={contact.name.full}/>}
          {emailAddress && <Forms.Field label="Email:" value={emailAddress}/>}
          {phoneNumber && <Forms.Field label="Phone:" value={Phone.format(phoneNumber, 'National')}/>}
        </ul>
      </div>
      <div className="list block">
        <ul>
          <Forms.Error {...form}/>
          <Forms.Textarea
            {...form}
            name="description"
            label="Description"
            className="invoice__description"
            required={true}
            autoFocus={true}/>
          <Forms.Input
            {...form}
            name="amount"
            type="tel"
            assistType="money"
            label="Total Amount"
            defaultValue="0"
            required={true}
            autoComplete="off"/>
          <Forms.Checkbox
            {...form}
            name="deposit"
            label="Deposit"/>
          <Forms.Button {...form} label="Send Payment Request"/>
        </ul>
      </div>
    </div>
  );
}
